import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SearchForm from '../components/SearchForm'

export default function SearchPage() {
  const navigate = useNavigate()
  const [isSearching, setIsSearching] = useState(false)

  const handleSearch = async (query: string) => {
    if (!query.trim()) return
    
    setIsSearching(true)
    
    try {
      // Navigate to results page with query
      navigate(`/search?q=${encodeURIComponent(query.trim())}`)
    } catch (error) {
      console.error('Search navigation failed:', error)
    } finally {
      setIsSearching(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col justify-center px-4">
      <div className="w-full">
        <SearchForm 
          onSearch={handleSearch}
          isLoading={isSearching}
          placeholder="Ask a question about web specs..."
        />
      </div>
    </div>
  )
}
